/**
 * Pure once-guards for web Christmas analytics (no PostHog client).
 */

export type WebChristmasAnalyticsDedupe = {
  reset: () => void;
  noteOfferingOpened: (offeringId: string) => boolean;
  noteCategoryChange: (category: "daily" | "christmas") => {
    fire: boolean;
    previous: "daily" | "christmas" | null;
  };
  noteQrInteraction: (christmasCount: number) => boolean;
  snapshot: () => {
    openedCount: number;
    lastCategory: "daily" | "christmas" | null;
    qrInteractionFired: boolean;
  };
};

export function createWebChristmasAnalyticsDedupe(): WebChristmasAnalyticsDedupe {
  const openedOfferings = new Set<string>();
  let lastCategory: "daily" | "christmas" | null = null;
  let qrInteractionFired = false;

  return {
    reset() {
      openedOfferings.clear();
      lastCategory = null;
      qrInteractionFired = false;
    },
    noteOfferingOpened(offeringId: string) {
      const id = offeringId.trim();
      if (!id || openedOfferings.has(id)) return false;
      openedOfferings.add(id);
      return true;
    },
    noteCategoryChange(category) {
      if (lastCategory === category) {
        return { fire: false, previous: lastCategory };
      }
      const previous = lastCategory;
      lastCategory = category;
      return { fire: true, previous };
    },
    noteQrInteraction(christmasCount: number) {
      if (qrInteractionFired) return false;
      if (christmasCount < 1) return false;
      qrInteractionFired = true;
      return true;
    },
    snapshot() {
      return {
        openedCount: openedOfferings.size,
        lastCategory,
        qrInteractionFired,
      };
    },
  };
}
